import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { adminUserAction } from "@/lib/adminUsers";

type ImpersonationState = {
  session_id: string;
  target_user_id: string;
  target_name: string;
  admin_user_id: string;
};

export function getImpersonationState(): ImpersonationState | null {
  const raw = localStorage.getItem("delapresse_impersonation");
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImpersonationState;
  } catch {
    localStorage.removeItem("delapresse_impersonation");
    return null;
  }
}

export default function ImpersonationBanner() {
  const [state, setState] = useState<ImpersonationState | null>(() => getImpersonationState());

  useEffect(() => {
    const update = () => setState(getImpersonationState());
    window.addEventListener("storage", update);
    return () => window.removeEventListener("storage", update);
  }, []);

  if (!state) return null;

  const end = async () => {
    await adminUserAction("end_impersonation", { user_id: state.target_user_id, session_id: state.session_id }).catch(() => null);
    localStorage.removeItem("delapresse_impersonation");
    window.dispatchEvent(new Event("storage"));
    setState(null);
  };

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-3 border-b border-warning/30 bg-warning/15 px-4 py-2 text-sm text-warning">
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4" />
        <span>You are currently logged in as {state.target_name}. Sensitive billing, password, security, and delete actions are restricted.</span>
      </div>
      <Button variant="outline" size="sm" onClick={end}>Return to admin account</Button>
    </div>
  );
}
